import React, { useState } from "react";
import "../SignIn/signIn.css";
import side_img from "../../assets/gamerclub our marketplace-03.png";
import { Col, Row } from "react-bootstrap";
import FormsAside from "../../Components/FormsAside/FormsAside";
import { notify, notify1 } from "../../Components/ToastComponent";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import { axios } from "../../api/axiosInterceptor";

const DzoUnsubscribe = () => {
  const { t } = useTranslation();
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleUnsubscribe = async (e) => {
    e.preventDefault();
    if (!phone.trim()) return;

    let msisdn = phone.trim();
    if (msisdn.indexOf("213") !== 0) {
      msisdn = "213" + msisdn;
    }

    setLoading(true);
    setErrorMsg("");

    try {
      const url = `https://vas1.grand-hub.com/api/gamerClub/ooredoo-alg-d-migrat/deactivate?phone=${msisdn}`;
      const res = await axios.get(url);

      if (res.data?.success) {
        notify(t("Unsubscribed successfully"));
        setPhone("");
      } else {
        const message = res.data?.message || t("Unsubscribe failed");
        setErrorMsg(message);
        notify1(message);
      }
    } catch (error) {
      const message =
        error?.response?.data?.message || t("Unsubscribe failed");
      setErrorMsg(message);
      notify1(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signUp">
      <ToastContainer />
      <Row
        className="mx-0"
        dir={localStorage.getItem("i18nextLng") === "ar" ? "rtl" : "ltr"}
      >
        <FormsAside side_img={side_img} />
        <Col xs={12} md={7} lg={8} xl={8} className="form">
          <Row className="h-10" style={{ paddingTop: "10%" }}>
            <Col className="m-auto" xs={12} md={8} lg={6}>
              <h1>{t("unsubscribe")}</h1>
              {errorMsg ? (
                <div className="alert alert-danger">{errorMsg}</div>
              ) : null}
              <form className="signUp-form" onSubmit={handleUnsubscribe}>
                <input
                  className="input px-2"
                  dir={
                    localStorage.getItem("i18nextLng") === "ar" ? "rtl" : "ltr"
                  }
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  type="tel"
                  name="phone"
                  placeholder={t("Phone Number")}
                  required
                />
                <div className="submit-info mt-3">
                  <button
                    className="btn-submit"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <i className="fas fa-spinner fa-spin"></i>
                    ) : (
                      t("unsubscribe")
                    )}
                  </button>
                </div>
              </form>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default DzoUnsubscribe;
